"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.currencyThousandsNoDecimalZeroDash = exports.usdThousandsNoDecimalZeroDash = exports.currencyThousandsDecimalDash = exports.usdThousandsDecimalDash = exports.currencyThousandsNoDecimalNm = exports.usdThousandsNoDecimalNm = exports.currencyThousandsNoDecimalDash = exports.usdThousandsNoDecimalDash = exports.currencyThousandsNoDecimalK = exports.usdThousandsNoDecimalK = exports.currencyThousandsNoDecimal = exports.usdThousandsNoDecimal = exports.nullableCurrencyDecimalDash = exports.nullableUsdDecimalDash = exports.currencyDecimalDash = exports.usdDecimalDash = exports.percentPLSingleDecimal = exports.percentDoubleDecimal = exports.percentSingleDecimal = exports.percentNoDecimal = exports.usdPLNoDecimalSpaced = exports.usdPL2Decimal = exports.usdPLNoDecimal = exports.usdNoDecimal = exports.usd2Decimal = exports.usd1Decimal = exports.usdDecimal = exports.currencyPLNoDecimalSpaced = exports.pLNoDecimal = exports.currencyNegativeBrackets = exports.currencyPL2Decimal = exports.currencyPLNoDecimal = exports.currencyNoDecimal = exports.currency2Decimal = exports.currency1Decimal = exports.currencyDecimal = exports.percentToFloat = exports.thousands = exports.clamp100Percent = exports.nmIfNonPositive = exports.dashIfNonPositive = exports.dashIfUndefined = exports.dashIfZero = exports.nonMeaningful = exports.dash = exports.withK = exports.withSuffix = exports.getFilterOrElse = exports.getConst = exports.getFromNumeralFormat = void 0;
exports.currencyWebAppGeneric = exports.noDecimalWithBrackets = exports.currencyNoDecimalWithBrackets = exports.currencyProfitNoDecimal = exports.profitNoDecimal = exports.currencyFundProfitThousands = exports.currencyFundProfit = exports.fundProfit = exports.irrSingleDecimal = exports.irrDoubleDecimal = exports.irrWithNM = exports.fundIrr = exports.statsIrr = exports.currencyPL2DecimalDash = exports.usdPL2DecimalDash = exports.currencyThousandsNoDecimalDashK = exports.usdThousandsNoDecimalDashK = exports.currencyPLThousandsK = exports.plThousandsK = exports.totalMom = exports.fundMom = exports.statsMom = exports.dpiExtended = exports.dpi = exports.allocationPercentage = exports.currencyPLThousands = exports.plThousands = exports.currencyPL = exports.totalIrr = exports.multiple2 = exports.multiple1 = exports.multiple2WithoutSuffix = exports.multiple1WithoutSuffix = void 0;
const fp_ts_1 = require("fp-ts");
const S_N = __importStar(require("fp-ts-std/Number"));
const S_S = __importStar(require("fp-ts-std/Show"));
// @see http://numeraljs.com/#format
const numeral_1 = __importDefault(require("numeral"));
const date_1 = require("./date");
// override millions abbreviation from 'm' to 'mm'
// override billions abbreviation from 'b' to 'bn'
// eslint-disable-next-line functional/no-expression-statements, functional/immutable-data, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access
numeral_1.default.localeData().abbreviations = {
    ...numeral_1.default.localeData().abbreviations,
    million: "mm",
    billion: "bn"
};
// ----------------------------------------------------------------------------
// constructors
// ----------------------------------------------------------------------------
/**
 * Returns a Show that converts a number to a string using the given numeral format.
 */
const getFromNumeralFormat = (format, currency = "USD") => ({
    show: (n) => 
    // Numeral does not support switching locale on the fly, so we have to
    // replace the $ symbol with the correct currency symbol.
    (0, numeral_1.default)(n).format(format).replace("$", currencySymbol(currency))
});
exports.getFromNumeralFormat = getFromNumeralFormat;
/**
 * Returns a Show that always returns the given string.
 */
const getConst = (value) => ({
    show: () => value
});
exports.getConst = getConst;
// ----------------------------------------------------------------------------
// combinators
// ----------------------------------------------------------------------------
const getFilterOrElse = (predicate, orElse) => (show) => ({
    show: (a) => (predicate(a) ? show.show(a) : orElse.show(a))
});
exports.getFilterOrElse = getFilterOrElse;
const withSuffix = (suffix) => (show) => ({
    show: (a) => show.show(a) + suffix
});
exports.withSuffix = withSuffix;
const withK = (s) => ({
    show: (n) => (n !== 0 ? (0, exports.withSuffix)("k")(s).show(n) : s.show(n))
});
exports.withK = withK;
// ----------------------------------------------------------------------------
// instances
// ----------------------------------------------------------------------------
// type classes
// const values
exports.dash = (0, exports.getConst)("-");
exports.nonMeaningful = (0, exports.getConst)("n.m.");
// clamps
exports.dashIfZero = (0, exports.getFilterOrElse)(_ => _ !== 0, exports.dash);
exports.dashIfUndefined = (0, exports.getFilterOrElse)(_ => typeof _ !== "undefined", exports.dash);
exports.dashIfNonPositive = (0, exports.getFilterOrElse)(S_N.isPositive, exports.dash);
exports.nmIfNonPositive = (0, exports.getFilterOrElse)(S_N.isPositive, exports.nonMeaningful);
exports.clamp100Percent = (0, exports.getFilterOrElse)(_ => _ <= 100, (0, exports.getConst)(">100%"));
// functors
exports.thousands = S_S.contramap(_ => Math.round(_ / 1000.0));
exports.percentToFloat = S_S.contramap(_ => Math.abs(_) >= 0.1 ? _ / 100.0 : 0);
const currencySymbol = (currency) => currency === "EUR" ? "€" : "$";
const currencyDecimal = (c) => (0, exports.getFromNumeralFormat)("$0,0.00", c);
exports.currencyDecimal = currencyDecimal;
const currency1Decimal = (c) => (0, exports.getFromNumeralFormat)("($0,0.0a)", c);
exports.currency1Decimal = currency1Decimal;
const currency2Decimal = (c) => (0, exports.getFromNumeralFormat)("($ 0,0.00a)", c);
exports.currency2Decimal = currency2Decimal;
const currencyNoDecimal = (c) => (0, exports.getFromNumeralFormat)("$0,0", c);
exports.currencyNoDecimal = currencyNoDecimal;
const currencyPLNoDecimal = (c) => (0, exports.getFromNumeralFormat)("($0,0)", c);
exports.currencyPLNoDecimal = currencyPLNoDecimal;
const currencyPL2Decimal = (c) => (0, exports.getFromNumeralFormat)("($0,0.00)", c);
exports.currencyPL2Decimal = currencyPL2Decimal;
const currencyNegativeBrackets = (c) => (0, exports.getFromNumeralFormat)("($0,0)", c);
exports.currencyNegativeBrackets = currencyNegativeBrackets;
exports.pLNoDecimal = (0, exports.getFromNumeralFormat)("(0,0)");
exports.currencyPLNoDecimalSpaced = (0, exports.getFromNumeralFormat)("(0,0)");
/**
 * @deprecated use currencyDecimal instead
 */
exports.usdDecimal = (0, exports.getFromNumeralFormat)("$0,0.00");
/**
 * @deprecated use currency1Decimal instead
 */
exports.usd1Decimal = (0, exports.getFromNumeralFormat)("($0,0.0a)");
/**
 * @deprecated use currency2Decimal instead
 */
exports.usd2Decimal = (0, exports.getFromNumeralFormat)("($ 0,0.00a)");
/**
 * @deprecated use currencyNoDecimal instead
 */
exports.usdNoDecimal = (0, exports.getFromNumeralFormat)("$0,0");
/**
 * @deprecated use currencyPLNoDecimal instead
 */
exports.usdPLNoDecimal = (0, exports.getFromNumeralFormat)("($0,0)");
/**
 * @deprecated use currencyPL2Decimal instead
 */
exports.usdPL2Decimal = (0, exports.getFromNumeralFormat)("($0,0.00)");
/**
 * @deprecated use currencyPLNoDecimalSpaced instead
 */
exports.usdPLNoDecimalSpaced = exports.currencyPLNoDecimalSpaced;
exports.percentNoDecimal = (0, exports.getFromNumeralFormat)("0%");
exports.percentSingleDecimal = (0, exports.getFromNumeralFormat)("0.0%");
exports.percentDoubleDecimal = (0, exports.getFromNumeralFormat)("0.00%");
exports.percentPLSingleDecimal = (0, exports.getFromNumeralFormat)("(0.0%)");
// combinations
/**
 * @deprecated use currencyDecimalDash instead
 */
exports.usdDecimalDash = fp_ts_1.function.pipe(exports.usdDecimal, exports.dashIfNonPositive);
const currencyDecimalDash = (c) => fp_ts_1.function.pipe((0, exports.currencyDecimal)(c), exports.dashIfNonPositive);
exports.currencyDecimalDash = currencyDecimalDash;
/**
 * @deprecated user nullableCurrencyDecimalDash instead
 */
exports.nullableUsdDecimalDash = fp_ts_1.function.pipe(exports.usdDecimal, exports.dashIfUndefined, exports.dashIfZero);
const nullableCurrencyDecimalDash = (c) => fp_ts_1.function.pipe((0, exports.currencyDecimal)(c), exports.dashIfUndefined, exports.dashIfZero);
exports.nullableCurrencyDecimalDash = nullableCurrencyDecimalDash;
/**
 * @deprecated use currencyThousandsNoDecimal instead
 */
exports.usdThousandsNoDecimal = fp_ts_1.function.pipe(exports.usdNoDecimal, exports.thousands);
const currencyThousandsNoDecimal = (c) => fp_ts_1.function.pipe((0, exports.currencyNoDecimal)(c), exports.thousands);
exports.currencyThousandsNoDecimal = currencyThousandsNoDecimal;
/**
 * @deprecated use currencyThousandsNoDecimalK instead
 */
exports.usdThousandsNoDecimalK = fp_ts_1.function.pipe(exports.usdNoDecimal, exports.withK, exports.thousands);
const currencyThousandsNoDecimalK = (c) => fp_ts_1.function.pipe((0, exports.currencyNoDecimal)(c), exports.withK, exports.thousands);
exports.currencyThousandsNoDecimalK = currencyThousandsNoDecimalK;
/**
 * @deprecated use currencyThousandsNoDecimalDash instead
 */
exports.usdThousandsNoDecimalDash = fp_ts_1.function.pipe(exports.usdThousandsNoDecimal, exports.dashIfNonPositive);
const currencyThousandsNoDecimalDash = (c) => fp_ts_1.function.pipe((0, exports.currencyThousandsNoDecimal)(c), exports.dashIfNonPositive);
exports.currencyThousandsNoDecimalDash = currencyThousandsNoDecimalDash;
/**
 * @deprecated use currencyThousandsNoDecimalNm instead
 */
exports.usdThousandsNoDecimalNm = fp_ts_1.function.pipe(exports.usdNoDecimal, exports.thousands, exports.nmIfNonPositive);
const currencyThousandsNoDecimalNm = (c) => fp_ts_1.function.pipe((0, exports.currencyNoDecimal)(c), exports.thousands, exports.nmIfNonPositive);
exports.currencyThousandsNoDecimalNm = currencyThousandsNoDecimalNm;
/**
 * @deprecated use currencyThousandsDecimalDash instead
 */
exports.usdThousandsDecimalDash = fp_ts_1.function.pipe(exports.usdDecimal, exports.thousands, exports.dashIfNonPositive);
const currencyThousandsDecimalDash = (c) => fp_ts_1.function.pipe((0, exports.currencyDecimal)(c), exports.thousands, exports.dashIfNonPositive);
exports.currencyThousandsDecimalDash = currencyThousandsDecimalDash;
/**
 * @deprecated use currencyThousandsNoDecimalZeroDash instead
 */
exports.usdThousandsNoDecimalZeroDash = fp_ts_1.function.pipe(exports.usdThousandsNoDecimal, exports.dashIfZero);
const currencyThousandsNoDecimalZeroDash = (c) => fp_ts_1.function.pipe((0, exports.currencyThousandsNoDecimal)(c), exports.dashIfZero);
exports.currencyThousandsNoDecimalZeroDash = currencyThousandsNoDecimalZeroDash;
exports.multiple1WithoutSuffix = (0, exports.getFromNumeralFormat)("(0.0)");
exports.multiple2WithoutSuffix = (0, exports.getFromNumeralFormat)("(0.00)");
exports.multiple1 = fp_ts_1.function.pipe(exports.multiple1WithoutSuffix, (0, exports.withSuffix)("x"));
exports.multiple2 = fp_ts_1.function.pipe(exports.multiple2WithoutSuffix, (0, exports.withSuffix)("x"));
exports.totalIrr = fp_ts_1.function.pipe(exports.percentPLSingleDecimal, exports.percentToFloat);
const currencyPL = (c) => fp_ts_1.function.pipe((0, exports.currencyPLNoDecimal)(c), exports.dashIfZero);
exports.currencyPL = currencyPL;
/**
 * @deprecated use currencyPLThousands instead
 */
exports.plThousands = fp_ts_1.function.pipe(exports.usdPLNoDecimal, exports.dashIfZero, exports.thousands);
const currencyPLThousands = (c) => fp_ts_1.function.pipe((0, exports.currencyPL)(c), exports.thousands);
exports.currencyPLThousands = currencyPLThousands;
exports.allocationPercentage = fp_ts_1.function.pipe(exports.percentSingleDecimal, exports.dashIfNonPositive, exports.percentToFloat);
exports.dpi = fp_ts_1.function.pipe(exports.multiple2, (0, exports.getFilterOrElse)(S_N.isPositive, exports.dash));
exports.dpiExtended = (0, exports.getFromNumeralFormat)("(0.[0])");
exports.statsMom = exports.multiple2;
exports.fundMom = fp_ts_1.function.pipe(exports.multiple1, (0, exports.getFilterOrElse)(_ => _ >= 0.9, exports.nonMeaningful));
exports.totalMom = exports.multiple1;
/**
 * @deprecated use currencyPLThousandsK instead
 */
exports.plThousandsK = fp_ts_1.function.pipe(exports.plThousands, exports.withK);
const currencyPLThousandsK = (c) => fp_ts_1.function.pipe((0, exports.currencyPLThousands)(c), exports.withK);
exports.currencyPLThousandsK = currencyPLThousandsK;
/**
 * @deprecated use currencyThousandsNoDecimalDashK instead
 */
exports.usdThousandsNoDecimalDashK = fp_ts_1.function.pipe(exports.usdThousandsNoDecimalK, exports.dashIfNonPositive);
const currencyThousandsNoDecimalDashK = (c) => fp_ts_1.function.pipe((0, exports.currencyThousandsNoDecimalK)(c), exports.dashIfNonPositive);
exports.currencyThousandsNoDecimalDashK = currencyThousandsNoDecimalDashK;
/**
 * @deprecated use currencyPL2DecimalDash instead
 */
exports.usdPL2DecimalDash = fp_ts_1.function.pipe(exports.usdPL2Decimal, exports.dashIfZero);
const currencyPL2DecimalDash = (c) => fp_ts_1.function.pipe((0, exports.currencyPL2Decimal)(c), exports.dashIfZero);
exports.currencyPL2DecimalDash = currencyPL2DecimalDash;
exports.statsIrr = fp_ts_1.function.pipe(exports.percentSingleDecimal, exports.percentToFloat);
const isDateLessThanAYearAgo = (date) => Math.abs(new Date().getTime() - date.getTime()) < 1000 * 60 * 60 * 24 * 365;
const fundIrr = (profit, fundFirstCapitalCall) => fp_ts_1.function.pipe(exports.percentSingleDecimal, exports.dashIfNonPositive, exports.percentToFloat, exports.clamp100Percent, (0, exports.getFilterOrElse)(irr => profit > 0 &&
    (irr >= 0 ||
        (fundFirstCapitalCall !== undefined &&
            !isDateLessThanAYearAgo(fundFirstCapitalCall))), exports.nonMeaningful));
exports.fundIrr = fundIrr;
const irrWithNM = (params) => {
    const firstCallYears = params.firstCapitalCallDate
        ? (0, date_1.getYearsDifference)(new Date(params.firstCapitalCallDate))
        : null;
    const calledLessThanAYearAgo = firstCallYears !== null ? firstCallYears < 1 : false;
    const calledLessThanThreeYearsAgo = firstCallYears !== null ? firstCallYears < 3 : false;
    return fp_ts_1.function.pipe(exports.percentSingleDecimal, exports.percentToFloat, (0, exports.getFilterOrElse)(irr => params.profit > 0 && (irr >= 0 || !calledLessThanAYearAgo), exports.nonMeaningful), 
    // Add n.m. if MOM is between 0.93 and 1.07.
    (0, exports.getFilterOrElse)(() => params.mom <= 0.93 || params.mom >= 1.07, exports.nonMeaningful), 
    // Add n.m. if IRR is < 0 or > 100.
    (0, exports.getFilterOrElse)(irr => irr >= 0 && irr <= 100, exports.nonMeaningful), 
    // Add n.m. if the committed capital called is less then 25%.
    (0, exports.getFilterOrElse)(() => params.committedCapitalCalledPercent >= 25, exports.nonMeaningful), 
    // Add n.m. if the first call was more than 3 year ago.
    (0, exports.getFilterOrElse)(() => !calledLessThanThreeYearsAgo, exports.nonMeaningful));
};
exports.irrWithNM = irrWithNM;
exports.irrDoubleDecimal = fp_ts_1.function.pipe(exports.percentDoubleDecimal, exports.percentToFloat);
exports.irrSingleDecimal = fp_ts_1.function.pipe(exports.percentSingleDecimal, exports.percentToFloat);
/**
 * @deprecated use currencyFundProfit instead
 */
const fundProfit = (nav) => fp_ts_1.function.pipe(exports.plThousands, (0, exports.getFilterOrElse)(_ => _ > 0 || nav > 0, exports.nonMeaningful));
exports.fundProfit = fundProfit;
const currencyFundProfit = (c, formatter = exports.currencyPL) => (nav) => fp_ts_1.function.pipe(formatter(c), (0, exports.getFilterOrElse)(_ => _ > 0 || nav > 0, exports.nonMeaningful));
exports.currencyFundProfit = currencyFundProfit;
const currencyFundProfitThousands = (c) => (0, exports.currencyFundProfit)(c, exports.currencyPLThousands);
exports.currencyFundProfitThousands = currencyFundProfitThousands;
/**
 * @deprecated use currencyProfitNoDecimal instead
 */
exports.profitNoDecimal = fp_ts_1.function.pipe(exports.usdNoDecimal, exports.dashIfUndefined, exports.dashIfZero);
const currencyProfitNoDecimal = (c) => fp_ts_1.function.pipe((0, exports.currencyNoDecimal)(c), exports.dashIfUndefined, exports.dashIfZero);
exports.currencyProfitNoDecimal = currencyProfitNoDecimal;
const currencyNoDecimalWithBrackets = (c) => fp_ts_1.function.pipe((0, exports.currencyPLNoDecimal)(c), exports.dashIfUndefined, exports.dashIfZero);
exports.currencyNoDecimalWithBrackets = currencyNoDecimalWithBrackets;
exports.noDecimalWithBrackets = fp_ts_1.function.pipe(exports.pLNoDecimal, exports.dashIfUndefined, exports.dashIfZero);
/**
 * Main currency format used in the web app for generic
 * currencies values in the tables.
 */
const currencyWebAppGeneric = (c) => fp_ts_1.function.pipe((0, exports.currencyNegativeBrackets)(c), exports.dashIfZero);
exports.currencyWebAppGeneric = currencyWebAppGeneric;
